import { forwardRef, useMemo } from 'react';

import { EventCard } from 'hb-react/shared/apps/Events/components/EventCard';
import EventCardLoading from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/EventCardLoading';
import { type EventCardProps } from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/types';
import { transformEventForCard } from 'hb-react/shared/apps/Events/components/EventsIndexContainer/utils/transformEventForCard';

const EventCardContainer = forwardRef<HTMLDivElement, EventCardProps>(
  (props, ref) => {
    const { event, ...restProps } = props;

    const eventCardProps = useMemo(() => transformEventForCard(event), [event]);

    return <EventCard event={eventCardProps} ref={ref} {...restProps} />;
  },
);

export const EventCardV2 = forwardRef<HTMLDivElement, EventCardProps>(
  (props, ref) => {
    const { loading, ...restProps } = props;

    if (loading) {
      return <EventCardLoading />;
    }

    return <EventCardContainer ref={ref} {...restProps} />;
  },
);
